import React, { useEffect, useState } from "react"
import { Container, Button } from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import {
  useDeleteAccountInvestorMutation,
  useDeleteAccountWealthPartnerMutation,
} from "store/api/investorapi/auth.api"
import { useLogout } from "hooks/useLogout"
import { useSelector } from "react-redux"
import DeleteConfirmationModal from "./deleteConfirmation"

const ProfileDelete = () => {
  const { userType, user } = useSelector((state) => state.user)
  const [onDelete, { isLoading }] = useDeleteAccountInvestorMutation()
  const [onDeleteWp, { isLoading: isDeleting }] =
    useDeleteAccountWealthPartnerMutation()
  const logout = useLogout()
  const [isToast, setIsToast] = useState(false)

  const { permissions } = useSelector((state) => state.user)
  const navigate = useNavigate()

  useEffect(() => {
    if (permissions.length > 0) {
      if (userType === "INVESTOR" && user.user_type === "SUB_INVESTOR") {
        navigate("/forbidden")
      }
    }
  }, [userType, user])

  const handleOnSuccess = () => {
    setIsToast(false)
    logout()
  }

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <React.Fragment>
            <div
              className={
                "py-4 d-flex flex-column align-items-center justify-content-between"
              }
            >
              <h4
                style={{
                  color: "#df0000",
                  fontSize: "32px",
                  fontWeight: "600",
                  marginBottom: "25px",
                }}
              >
                {`Delete Account`}
              </h4>
              <div
                style={{
                  color: "#000000",
                  fontSize: "16px",
                  maxWidth: "500px",
                  margin: "0 auto",
                }}
              >
                <ul>
                  <li>
                    <p>
                      Your profile and all associated data are scheduled for
                      permanent deletion after <strong>30 days</strong>.
                    </p>
                  </li>
                  <li>
                    <p>
                      If you <strong>log in again during this period</strong>,
                      the deletion request will be cancelled, and your account
                      will remain active.
                    </p>
                  </li>
                  <li>
                    <p>
                      After 30 days without logging in, your account will be
                      permanently deleted and cannot be restored.
                    </p>
                  </li>
                </ul>
              </div>

              <div
                className="buttons"
                style={{
                  marginTop: "20px",
                }}
              >
                <Button
                  type="button"
                  className="primary"
                  style={{
                    background: "#df0000",
                    borderColor: "#df0000",
                  }}
                  onClick={() => setIsToast(true)}
                >
                  Yes, Delete Account
                </Button>
              </div>
            </div>
            <DeleteConfirmationModal
              open={isToast}
              setOpen={setIsToast}
              isLoading={isLoading || isDeleting}
              onClose={() => {
                setIsToast(false)
              }}
              title={"Delete Account"}
              description="Are you sure you want to delete your account?"
              onDelete={userType === "INVESTOR" ? onDelete : onDeleteWp}
              onSuccess={handleOnSuccess}
            />
          </React.Fragment>
        </Container>
      </div>
    </>
  )
}

export default ProfileDelete
